import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { t, lang, admin, login } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success(lang === "en" ? "Welcome back" : "మరల స్వాగతం");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="bg-[#fbf8f1] min-h-[80vh] grid place-items-center px-4">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md bg-white border border-stone-200 rounded-sm p-8 shadow-sm"
      >
        <div className="text-[11px] tracking-[0.2em] uppercase text-[#b45f06] font-semibold mb-2">
          SVRM
        </div>
        <h1 className="text-2xl font-semibold text-stone-900">{t.admin.login}</h1>
        <div className="mt-6 space-y-4">
          <div>
            <label className="text-xs tracking-wider uppercase text-stone-500 font-semibold">{t.admin.email}</label>
            <input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full bg-[#fafaf9] border border-stone-300 rounded-sm px-3 py-2.5 focus:outline-none focus:border-[#274e13]"
              required
            />
          </div>
          <div>
            <label className="text-xs tracking-wider uppercase text-stone-500 font-semibold">{t.admin.password}</label>
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full bg-[#fafaf9] border border-stone-300 rounded-sm px-3 py-2.5 focus:outline-none focus:border-[#274e13]"
              required
            />
          </div>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#274e13] hover:bg-[#38761d] text-white py-3 rounded-sm font-semibold tracking-wide transition-colors disabled:opacity-60"
          >
            {loading ? t.checkout.sending : t.admin.signIn}
          </button>
        </div>
      </form>
    </div>
  );
}
